import request from "@/utils/request";

export default function agentGetAllUserList(params) {
  return request({
    url: `/user/userManage/agentGetAllUserList`,
    params,
  });
}
